const state = {
  webInfo: {
    title: '空白页面1',
    description: '',
    shareIcon: '',
    bgImage: '',
    bgColor: '#fff',
    cover: ''
  },
  followInfo: {
    enable: false,
    linkId: ''
  },
  launchScreen: {
    enable: false,
    type: 'image',
    src: '',
    delay: 3,
    hasSkip: false,
    skipText: '立即跳过'
  },
  moduleList: [],
  checkMode: false,
  currentModuleIndex: 0,
  checkElementList: []
}

const getters = {
  currentModule (state) {
    return state.moduleList[state.currentModuleIndex]
  }
}

const mutations = {
  // 设置选择模式
  SET_CHECK_MODE (state, flag) {
    state.checkMode = flag
  },
  // 设置元素列表
  SET_CHECK_ELEMENT_LIST (state, list) {
    state.checkElementList = list
  },
  // 设置页面组件列表
  SET_MODULE_LIST (state, list) {
    state.moduleList = list
  },
  // 设置当前选中的组件
  SET_CURRENT_MODULE (state, data) {
    state.moduleList[state.currentModuleIndex] = data
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}
